export const communityHomeL10n = {
    ko: {
        viewAll : '전체보기',
        lwYoutube : 'Lineage W 공식 유튜브 채널',
        myProfile : '내 프로필',
        cmPick : 'CM 픽',
        pop : '인기',
        myFeed : 'MY 피드',
        myFeedBeforeLogin : '로그인 후 나를 위한 맞춤 콘텐츠를 확인해보세요.',
        login : '로그인',
        myFeedNoData : '업데이트된 새 글이 없습니다.',
        myFeedInfo : 'MY 피드에서는 혈맹 게시판의 새 글을 모아 보여드립니다.',
        pageError : '일시적으로 페이지를 불러올 수 없습니다. <br> 잠시 후 다시 접속해주세요.',
        count : '조회',
        seeMore : '더보기'
    },
    ar: {
        viewAll : 'عرض الكل',
        lwYoutube : 'قناة Youtube الرسمية لـLineage W',
        myProfile : 'ملفي',
        cmPick : 'اختيار CM',
        pop : 'شعبي',
        myFeed : 'حائط MY',
        myFeedBeforeLogin : 'تحقق من المحتوى المخصص لك بعد تسجيل الدخول.',
        login : 'تسجيل الدخول',
        myFeedNoData : 'لا يوجد منشور مسجل حديثا.',
        myFeedInfo : 'حائط MY يحتوي على المنشورات الجديدة الخاصة بلوحة إعلانات عهد الدم.',
        pageError : 'لن يمكن استدعاء الصفحة مؤقتا.<br> الرجاء إعادة المحاولة لاحقا.',
        count : 'مشاهدة',
        seeMore : 'عرض المزيد'
    },
    en: {
        viewAll : 'View All',
        lwYoutube : 'Lineage W Official YouTube Channel',
        myProfile : 'My Profile',
        cmPick : 'CM Pick',
        pop : 'Popular',
        myFeed : 'My Feed',
        myFeedBeforeLogin : 'Sign in to see personalized content.',
        login : 'Sign In',
        myFeedNoData : 'There are no newly registered posts.',
        myFeedInfo : 'My Feed has all of the newly created posts from the Guild Board.',
        pageError : 'Unable to load the page temporarily.<br>Please try again later.',
        count : 'View',
        seeMore : 'View More'
    },
    id: {
        viewAll : 'Lihat Semua',
        lwYoutube : 'Channel YouTube Resmi Lineage W',
        myProfile : 'Profil Saya',
        cmPick : 'Pilihan CM',
        pop : 'Populer',
        myFeed : 'Feed Saya',
        myFeedBeforeLogin : 'Silakan login dan cek konten yang disesuaikan untuk Anda.',
        login : 'Login',
        myFeedNoData : 'Tidak ada postingan baru.',
        myFeedInfo : 'Postingan baru di Board Klan dapat dilihat di Feed Saya.',
        pageError : 'Tidak dapat memuat halaman untuk sementara.<br>Silakan coba beberapa saat lagi.',
        count : 'Views',
        seeMore : 'Lihat Lebih Banyak'
    },
    ja: {
        viewAll : '全体リストを見る',
        lwYoutube : 'Lineage W公式YouTubeチャンネル',
        myProfile : 'マイプロフィール',
        cmPick : 'CMピックアップ',
        pop : '人気',
        myFeed : 'Myフィード',
        myFeedBeforeLogin : 'ログインし、お好みのコンテンツをご確認ください。',
        login : 'ログイン',
        myFeedNoData : '新しい投稿がありません。',
        myFeedInfo : 'Myフィードでは血盟掲示板の新しい投稿をまとめて確認できます。',
        pageError : '一時的にページを読み込むことができません。 <br>しばらくしてからもう一度お試しください。',
        count : '閲覧数',
        seeMore : 'もっと見る'
    },
    ru: {
        viewAll : 'Посмотреть всё',
        lwYoutube : 'Официальный канал YouTube Lineage W',
        myProfile : 'Мой профиль',
        cmPick : 'Выбор CM',
        pop : 'Популярное',
        myFeed : 'Моя лента',
        myFeedBeforeLogin : 'Войдите в аккаунт, чтобы посмотреть персонализированный контент.',
        login : 'Вход',
        myFeedNoData : 'Нет новых публикаций.',
        myFeedInfo : 'В Моей ленте вы можете проверить новые публикации на доске гильдии.',
        pageError : 'Данная страница временно недоступна.<br>Повторите попытку позже.',
        count : 'Просмотры',
        seeMore : 'Еще'
    },
    th: {
        viewAll : 'ดูทั้งหมด',
        lwYoutube : 'ช่อง YouTube ทางการของ Lineage W',
        myProfile : 'โปรไฟล์ฉัน',
        cmPick : 'CM Pick',
        pop : 'ยอดฮิต',
        myFeed : 'ฟีดของฉัน',
        myFeedBeforeLogin : 'เข้าสู่ระบบแล้วตรวจสอบคอนเทนต์ที่เหมาะสมกับฉัน',
        login : 'เข้าสู่ระบบ',
        myFeedNoData : 'ไม่มีโพสต์ที่อัปเดตไว้',
        myFeedInfo : 'ในฟีดของฉัน จะรวมโพสต์ใหม่ของกระทู้แคลน',
        pageError : 'ไม่สามารถโหลดหน้าเพจนี้ได้ชั่วคราว<br>กรุณาลองเชื่อมต่อใหม่อีกสักครู่',
        count : 'รับชม',
        seeMore : 'ดูเพิ่มเติม'
    },
    zh: {
        viewAll : '全部查看',
        lwYoutube : '天堂W官方YouTube頻道',
        myProfile : '我的個人資料',
        cmPick : 'CM精選',
        pop : '人氣',
        myFeed : 'MY專屬',
        myFeedBeforeLogin : '請登入查看為您專屬的個人化內容。',
        login : '登入',
        myFeedNoData : '沒有新的文章。',
        myFeedInfo : '在MY專屬，為您彙整血盟討論版的新文章。',
        pageError : '暫時無法讀取頁面。<br>請稍後再重試一次。',
        count : '觀看次數',
        seeMore : '查看更多'
    }
}